import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ActionResult, RaceRoute} from "@model";
import {Observable, map} from "rxjs";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class RaceRouteService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  fetchRaceRoute(raceId: number): Observable<RaceRoute|undefined> {
    return this.http.post<ActionResult<RaceRoute|undefined>>(this.environmentService.getApiUrl() + "/api/public/race/route/fetch", raceId).pipe(map((actionResult: ActionResult<RaceRoute|undefined>) => {
      if (actionResult.resultCode !== -1) {
        return actionResult.result;
      } else {
        return undefined;
      }
    }));
  }

  downloadGpx(path: string, onLoadend: (base64data: string) => void): void {
    // @ts-ignore
    this.http.get(path, {
      responseType: 'blob' // this tells angular to parse it
      // as a blob, default is json
    }).subscribe((res: Blob) => {
      const reader: FileReader = new FileReader();
      reader.onloadend = () => {
        var base64data = reader.result;
        if (base64data && typeof base64data === 'string') {
          onLoadend(base64data);
        }
      }

      reader.readAsDataURL(res);
    });
  }

  updateRaceRoute(raceRoute: RaceRoute, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/race/route/add", raceRoute)
      .subscribe((actionResult: ActionResult<boolean>):void => {
        if (actionResult.resultCode !== -1) {
          onSuccess()
        } else {
          onError();
        }
      });
  }

  deleteRaceRoute(raceId: number, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/race/route/delete", raceId)
      .subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.resultCode !== -1) {
          onSuccess();
        } else {
          onError();
        }
      });
  }
}
